import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VisualiserMessages } from '../../../shared/models/component-messages/visualiser-messages';
import { AvisService } from '../../services/avis-service';

@Component({
	selector: 'app-popup-dupliquer',
	templateUrl: './popup-dupliquer.component.html'
})
export class PopupDupliquerComponent implements OnInit {
	@Input() isCorriger : boolean = false;

	public visualiserMessages = new VisualiserMessages();
	public referenceAvis: string;
	public messageToShow: string;

	constructor(public activeModal: NgbActiveModal, private avisService: AvisService) {}

	public ngOnInit() {
		this.messageToShow = this.visualiserMessages.popupDupliquerDesc
		if(this.isCorriger === true){
			this.messageToShow = this.visualiserMessages.popupCorrigerDesc
		}
	}

	public shouldUpdateSynthesis(value: boolean): void {
		this.avisService.shouldUpdateSynthesis = value;
		this.activeModal.close(value);
	}
}
